import { DEFAULT_BUILDER_GO_SETTINGS } from 'Containers/App/constants';
import { ClaimsFormStatus } from 'Containers/ProfilePage/types';
import { validConfig } from 'Fixtures/config';

export const publicationInfo = {
  publication: {
    jv_publication_uuid: '',
    jv_employer_uuid: '',
    slug: '',
    target: '',
    data_revision_location: '',
    pbf_config_location: '',
    is_integrated: false,
    alex_id_enabled: false,
    sso_enabled: false,
    sso_connection_name: null,
    forced_authentication: false,
    plan_year: 1,
    use_comm_api: false,
    sex_at_birth_enabled: false,
    allow_sex_at_birth_no_answer_enabled: false,
    conduent_script_enabled: false,
    docfinder_enabled: true,
    plan_start_date: '',
    plan_end_date: '',
    oe_start_date: '',
    oe_end_date: '',
    go_settings: DEFAULT_BUILDER_GO_SETTINGS,
    has_healthfund_incentives: false,
    has_premium_incentives: false,
    has_medicare: false,
    include_medicare: false,
    medical_coverage_age_exclusive: false,
    medical_oldest_coverage_age: 26,
    medical_oldest_college_coverage_age: 26,
  },
  enrollment_event: {
    id: '',
    employee_id: '',
    jv_publication_uuid: '',
    event_type: null,
    profile_complete: false,
    segment_slug: '',
  },
  eligibility_answers: [
    {
      answer_text: '',
      answer_integration_id: 123,
      jv_eligibility_question_id: '',
      source: '',
    },
  ],
  segment: {
    id: '',
    slug: '',
  },
};

export const profileContextProps = {
  canBearChild: false,
  hidePregnancyQuestion: false,
  showClientSurvey: false,
  survey: {
    risk_question_1: '',
    risk_question_2: '',
    plan_child_question: '',
    capacity_to_pay: '',
    enrollment_question: '',
  },
  progressMap: {},
  completed: [],
  isIntegrationPreFillEnabled: false,
  activePublicationInfo: publicationInfo,
  upcomingPublicationInfo: publicationInfo,
  incentiveSurvey: [],
  networkPreferenceSurvey: [],
  selectedPublicationKey: 'active' as const,
  incentiveSurveyAPICalled: false,
  integratedUserPublicationKey: null,
  claimsSummary: null,
  claimsError: null,
  claimsFormStatus: ClaimsFormStatus.Default,
  isClaimsFeatureEnabled: false,
  requestDebouncedHouseholdUpdate: () => {},
};

export const getFeatureFlags = () => {
  const config = validConfig().config;
  config.feature_flags = {
    is_profile_prefill_enabled: false,
    is_footer_test_enabled: false,
    is_skip_income_enabled: false,
    is_rue_landing_page_enabled: false,
    is_hide_eligibility_questions_enabled: false,
    is_educational_videos_enabled: true,
    is_cancer_insurance_enabled: false,
    is_profile_review_tool_enabled: false,
    is_no_deductible_plans_enabled: false,
    is_ulp_updates_enabled: false,
    is_go_teladoc_mtm_enabled: false,
    is_usersnap_enabled: false,
    is_go_talkspace_mtm_enabled: false,
    is_election_members_enabled: false,
    is_incentives_shortcut_enabled: false,
    is_life_ltc_enabled: false,
    is_medicare_content: false,
    is_hsa_funds_question_enabled: false,
    is_send_hsa_funds_to_comm_enabled: false,
    is_enrollment_plan_eligibility_enabled: false,
  };
  return config;
};

export const getCurrentYear = () => new Date().getFullYear();
